import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScrapingRed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2215_54746",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2215_54746)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.125 16.6668H3.33329C2.87496 16.6668 2.4826 16.5036 2.15621 16.1772C1.82982 15.8509 1.66663 15.4585 1.66663 15.0002V5.00016C1.66663 4.54183 1.82982 4.14947 2.15621 3.82308C2.4826 3.49669 2.87496 3.3335 3.33329 3.3335H16.6666C17.125 3.3335 17.5173 3.49669 17.8437 3.82308C18.1701 4.14947 18.3333 4.54183 18.3333 5.00016V15.0002C18.3333 15.4585 18.1701 15.8509 17.8437 16.1772C17.5173 16.5036 17.125 16.6668 16.6666 16.6668H15.5L11.5833 12.7502C11.2916 12.9446 10.9757 13.0904 10.6354 13.1877C10.2951 13.2849 9.9444 13.3335 9.58329 13.3335C8.54163 13.3335 7.65621 12.9689 6.92704 12.2397C6.19788 11.5106 5.83329 10.6252 5.83329 9.5835C5.83329 8.54183 6.19788 7.65641 6.92704 6.92725C7.65621 6.19808 8.54163 5.8335 9.58329 5.8335C10.625 5.8335 11.5104 6.19808 12.2395 6.92725C12.9687 7.65641 13.3333 8.54183 13.3333 9.5835C13.3333 9.9585 13.2847 10.3127 13.1875 10.646C13.0902 10.9793 12.9444 11.2918 12.75 11.5835L16.1666 15.0002H16.6666V5.00016H3.33329V15.0002H11.4583L13.125 16.6668ZM9.58329 11.6668C10.1666 11.6668 10.6597 11.4654 11.0625 11.0627C11.4652 10.6599 11.6666 10.1668 11.6666 9.5835C11.6666 9.00016 11.4652 8.50711 11.0625 8.10433C10.6597 7.70155 10.1666 7.50016 9.58329 7.50016C8.99996 7.50016 8.5069 7.70155 8.10413 8.10433C7.70135 8.50711 7.49996 9.00016 7.49996 9.5835C7.49996 10.1668 7.70135 10.6599 8.10413 11.0627C8.5069 11.4654 8.99996 11.6668 9.58329 11.6668Z",
			fill: "#CF4130"
		})
	})]
});
export default SvgScrapingRed;
